module.exports = __webpack_public_path__ + "img/robot.0280d791.webp";